import { call, put, select } from 'redux-saga/effects';

import { apiRequest } from '../../api/api.saga-services';
import * as api from '../../api/request-config/subscription.api';
import { getSubscriptionAccess } from '../subscription-access/subscription-access.saga-services';
import { subscriptionSelectors } from './subscription.selectors';

import * as actions from './subscription.actions';
import * as types from './subscription.types';

export function* storeSubscription(subscription: types.ISubscription) {
  yield put(actions.storeSubscription(subscription));
  return subscription;
}

export function* clearSubscription(subscriptionId: types.ISubscription['id']) {
  yield put(actions.clearSubscription(subscriptionId));
}

export function* clearAllSubscriptions() {
  const subscriptionIds: types.ISubscription['id'][] = yield select(subscriptionSelectors.selectResourceIds);
  for (const subscriptionId of subscriptionIds) {
    yield put(actions.clearSubscription(subscriptionId));
  }
}

export function* getSubscription() {
  const subscription = (yield call(apiRequest, api.getSubscriptionApi())) as types.ISubscription | null;

  yield call(clearAllSubscriptions);

  if (!subscription) {
    return null;
  }

  const subscriptionToStore = { ...subscription, id: String(subscription.id) };
  yield call(storeSubscription, subscriptionToStore);
  return subscriptionToStore;
}

export function* startBilling() {
  const subscription = (yield call(apiRequest, api.startBillingApi())) as types.ISubscription;
  if (!subscription) {
    return;
  }

  const subscriptionToStore = { ...subscription, id: String(subscription.id) };
  yield call(clearAllSubscriptions);
  yield call(storeSubscription, subscriptionToStore);
  yield call(getSubscriptionAccess);
  return subscriptionToStore;
}

export function* cancelSubscription() {
  const subscription = (yield call(apiRequest, api.deleteSubscriptionApi())) as types.ISubscription;
  if (!subscription) {
    return;
  }

  const subscriptionToStore = { ...subscription, id: String(subscription.id) };
  yield call(clearAllSubscriptions);
  yield call(storeSubscription, subscriptionToStore);
  yield call(getSubscriptionAccess);
  return subscriptionToStore;
}

export function* reactivateSubscription() {
  const subscription = (yield call(apiRequest, api.reactivateSubscriptionApi())) as types.ISubscription;
  if (!subscription) {
    return;
  }

  const subscriptionToStore = { ...subscription, id: String(subscription.id) };
  yield call(clearAllSubscriptions);
  yield call(storeSubscription, subscriptionToStore);
  yield call(getSubscriptionAccess);
  return subscriptionToStore;
}
